import React, { FC } from 'react';

import { IImageProperties } from '@helpers/utils';

import { ImageWrapper, MainImgComponent, MainImgWrapper } from './styled';

interface IMainImageProps {
  imageAttrs: IImageProperties;
}

export const MainImage: FC<IMainImageProps> = ({ imageAttrs }) => {
  return (
    <MainImgWrapper>
      <ImageWrapper>
        <MainImgComponent {...imageAttrs} loading="eager" />
      </ImageWrapper>
    </MainImgWrapper>
  );
};
